import { render, staticRenderFns } from "./DatatableAdvancedList.vue?vue&type=template&id=da622fa8&"
import script from "./DatatableAdvancedList.vue?vue&type=script&lang=js&"
export * from "./DatatableAdvancedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports